import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Button,
} from "@mui/material";

const ConfirmDialog = ({
  open,
  title = "Confirm",
  message = "",
  onConfirm,
  onCancel,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onCancel}
      PaperProps={{
        elevation: 0,
        sx: {
          boxShadow: "none",
          borderRadius: "12px",
          border: "1px solid #e0e0e0",
        },
      }}
      sx={{
        "& .MuiBackdrop-root": {
          backdropFilter: "blur(1px)",
          backgroundColor: "rgba(0, 0, 0, 0.2)", 
        },
      }}
    >
      <DialogTitle>{title}</DialogTitle>

      <DialogContent>
        <Typography>{message}</Typography>
      </DialogContent>

      <DialogActions>
        <Button
          onClick={onCancel}
          color="secondary"
          sx={{
            transition: "all 0.3s ease",
            borderRadius: "8px",
            padding: "6px 16px",
            backgroundColor: "#f5f5f5",
            color: "#333",
            ":hover": {
              backgroundColor: "#e0e0e0",
              transform: "scale(0.98)",
            },
          }}
        >
          Cancel
        </Button>

        <Button onClick={onConfirm} variant="contained" color="primary">
          Confirm
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmDialog;
